/*
 *  funthings.js — Fun Things hub (launcher)
 *
 *  The toy end of the site, split out of Kanoogiland. Kanoogiland is for the
 *  CREATOR tools — the things that build game content (mods, units, maps,
 *  universes, terrain objects). These tools are not that: you make a character
 *  or a reaction GIF for the fun of it, and neither produces anything the game
 *  loads. Mixing them into the same grid made the creator hub read as a pile of
 *  unrelated toys, so they get their own door.
 *
 *  The Orchestral Editor USED to be here on that reasoning ("a piece of music
 *  for the fun of it"), and it moved to Creator Tools on 2026-08-23 because the
 *  premise stopped being true: background music now ships from
 *  gs://kpubdata/music/ and plays in game, so what it authors IS game content.
 *
 *    1. Character  -> /character/
 *    2. GIF Maker  -> /gifmaker/
 *    3. Talks      -> /talks
 *
 *  Same shape as kanoogiland.js on purpose (tile registry -> grid, 1..N
 *  hotkeys, ?tool=<id> deep link, sign-in gate), so the two hubs stay siblings
 *  rather than drifting into two different launchers.
 *
 *  Copyright 2026 Kanoogi Inc. | All Rights Reserved.
 */

"use strict";

const kanoogi=window.kanoogi||{};
window.kanoogi=kanoogi;

import './style.css';
import * as Module_utils from '../../Kanlibs/KAN_Utils.js';
import * as signedin from './signedin.js';
import * as optionpanel from './optionpanel.js';
import { SigninHref } from '../../Kanlibs/KAN_SigninNext.js';	// keep where-they-were across sign-in

const utils=kanoogi.utils||new Module_utils.KAN_Utils();
window.kanoogi.utils=utils;

/* ---------------------------------------------------------------- */

// Same registry shape as kanoogiland.js. `href` keeps the trailing slash so the
// static folder serves directly without a 301 redirect hop.
const TOOLS=
	[
	{ id:'character', label:'Character',  href:'/character/', desc:'Draw a character, animate it, make it your mascot', icon:'✏️' },
	{ id:'gifmaker',  label:'GIF Maker',  href:'/gifmaker/',  desc:'Make a reaction GIF for the library (GIF Cohort)',  icon:'🎬' },
	{ id:'talks', label:'Talks', href:'/talks', desc:'Choose a presentation by Chris Taylor', icon:'🎤' },
	// Moved here from Creator Tools on 2026-09-27 (Chris): the creator tools went into Rock War,
	// and the Orchestral Editor is not a Rock War tool.
	{ id:'orchestral', label:'Orchestral Editor', href:'/orchestral/', desc:'Hum a theme, arrange real instruments, and conduct with AI', icon:'🎼' }
	];

let gridEl;

/* ---------------------------------------------------------------- */

function Go(href) { window.location.href=href; }

function MakeTiles()
	{
	TOOLS.forEach((t,i)=>
		{
		const a=document.createElement('a');
		a.className='kl-tile';
		a.href=t.href;					// real anchor — middle-click / open-in-new-tab work
		a.dataset.id=t.id;
		a.innerHTML=
			`<span class="kl-num">${i+1}</span>`+
			`<span class="kl-icon">${t.icon}</span>`+
			`<span class="kl-label">${t.label}</span>`+
			`<span class="kl-desc">${t.desc}</span>`;
		gridEl.appendChild(a);
		});
	}

function InitHotkeys()
	{
	window.addEventListener('keydown',(e)=>
		{
		if (e.metaKey||e.ctrlKey||e.altKey) return;		// leave browser/OS combos alone
		const tag=(e.target && e.target.tagName)||'';
		if (/^(INPUT|TEXTAREA|SELECT)$/.test(tag) || (e.target && e.target.isContentEditable)) return;

		// 1..N jump straight to a tool.
		if (e.key>='1' && e.key<=String(TOOLS.length))
			{
			const idx=parseInt(e.key,10)-1;
			if (TOOLS[idx]) { Go(TOOLS[idx].href); e.preventDefault(); }
			}
		});
	}

/* ---------------------------------------------------------------- */

function RedirectPage(url='/home') { window.location.href=url; }

(async()=>
	{
	utils.KanoogiTextLogo();

	await optionpanel.ValidateLogin();
	optionpanel.MenuState(true);

	if (!kanoogi.signedin) { RedirectPage(SigninHref()); return; }

	// Deep link: ?tool=<id> navigates straight to that tool (replace so Back
	// returns to wherever the user came from, not the bare launcher).
	const want=new URLSearchParams(location.search).get('tool');
	if (want)
		{
		const t=TOOLS.find(x=>x.id===want);
		if (t) { window.location.replace(t.href); return; }
		}

	const renderPageID=document.getElementById('renderpage');
	if (renderPageID) renderPageID.style.visibility='visible';

	gridEl=document.getElementById('kl-grid');
	MakeTiles();
	InitHotkeys();
	})();
